<template>
  <div class="ai-assistant-agent">
    <div class="ai-assistant-agent__title">添加智能体</div>
    <a class="ai-assistant-agent__close" @click.prevent="handleAgentClose">
      <a-icon type="close" />
    </a>
    <a-space direction="vertical" style="width: 100%;">
      <div
        v-for="(agent, index) in agents"
        :key="index"
        class="ai-assistant-agent-card"
        @click="onClick(agent)"
      >
        <div class="ai-assistant-agent__title">{{ agent.agent_name }}</div>
        <div class="ai-assistant-agent__desc">{{ agent.agent_desc }}</div>
      </div>
    </a-space>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('aiAssistant', ['agents', 'userAgents']),
    ...mapGetters(['activePane'])
  },
  watch: {
    'activePane.agentId': {
      immediate: true,
      deep: true,
      handler (val) {
        const item = this.agents.find((item) => item.agent_id === val)
        if (item) {
          this.onClick(item)
        }
      }
    }
  },
  methods: {
    onClick (prompt) {
      this.$store.dispatch('aiAssistant/setAgentsShow', false)
      const agrent = this.userAgents.find((item) => item.agent_id === prompt.agent_id)
      if (agrent) {
        this.$store.dispatch('aiAssistant/setUserAgentId', agrent.user_agent_id)
      } else {
        this.$store.dispatch('aiAssistant/send', {
          method: 'bindUserAgent',
          data: { agent_id: prompt.agent_id }
        })
      }
    },
    handleAgentClose () {
      this.$store.dispatch('aiAssistant/setAgentsShow', false)
    }
  }
}
</script>

<style lang="less" scoped>
.ai-assistant-agent {
  padding: 10px;
  width: 100%;
  position: relative;
}
.ai-assistant-agent__title {
  margin-bottom: 5px;
  color: #0B1019;
  font-size: 12px;
  font-weight: 700;
  line-height: 28px;
}
.ai-assistant-agent__desc {
  margin-bottom: 4px;
  color: #434B5B;
  font-size: 10px;
  font-weight: 300;
  // 最多显示两行
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ai-assistant-agent-card {
  margin-bottom: 8px;
  padding: 5px 8px;
  width: 100%;
  height: 74px;
  background: #fff;
  border: 1px solid #E5E8EB;
  border-radius: 4px;
  cursor: pointer;

  .ai-assistant-agent__title {
    text-align: left;
  }

  &:hover {
    border-color: #1E5AF9;

    .ai-assistant-agent__title,
    .ai-assistant-agent__desc {
      color: #1E5AF9;
    }
  }
}
.ai-assistant-agent__close {
  position: absolute;
  top: 13px;
  right: 14px;
  cursor: pointer;
}
</style>
